/** Admin role is stored in Supabase app_metadata (not user_metadata). */
export function isAdminUser(user) {
  return user?.app_metadata?.role === 'admin'
}
